export const state = () => ({
  widget: {}
});
